export const NOTE_CONTENT_MAX_LENGTH = 5000;

export type Note = {
    id: string;
    userId: string;
    content: string;
    createdAt: string;
    updatedAt: string;
};

export type PutNoteResponse = Note;
export type PutNoteInput = {
    content: string;
};
